import posthog from 'posthog-js';

const PoolMembershipAction = {
  ADDED: 'added',
  REMOVED: 'removed',
};

const PoolItemAction = {
  CLAIMED: 'claimed',
  TAKEN_OVER: 'taken_over',
};

const capturePoolMembershipChange = (actorUserId, coachId, action) => posthog.capture('pool_membership_changed', {
  actor_user_id: actorUserId,
  coach_id: coachId,
  action,
});

const capturePoolQueueViewed = (acUserId, {
  coachCount,
  openItemCount,
  unclaimedItemCount,
}) => posthog.capture('pool_queue_viewed', {
  ac_user_id: acUserId,
  pool_coach_count: coachCount,
  open_item_count: openItemCount,
  unclaimed_item_count: unclaimedItemCount,
});

const capturePoolItemActioned = (acUserId, {
  coachId,
  section,
  itemAgeDays,
  action,
}) => posthog.capture('pool_item_actioned', {
  ac_user_id: acUserId,
  coach_id: coachId,
  item_id: section,
  item_age_days: itemAgeDays,
  action,
});

const capturePoolItemReleased = (acUserId, { coachId, section }) => posthog.capture('pool_item_released', {
  ac_user_id: acUserId,
  coach_id: coachId,
  item_id: section,
});

export {
  PoolMembershipAction,
  PoolItemAction,
  capturePoolMembershipChange,
  capturePoolQueueViewed,
  capturePoolItemActioned,
  capturePoolItemReleased,
};
